import Tool, { type ToolArgs } from './Tool';
import { ReactEditor } from 'slate-react';
import { Transforms } from 'slate';

class ToolDelete extends Tool {
  static toolName = 'Delete';
  static iconClass = 'fa-solid fa-trash';

  static action({ editor, element }: ToolArgs): void {
    if (!element) return;

    const path = ReactEditor.findPath(editor, element);
    Transforms.removeNodes(editor, { at: path });
  }
}

export default ToolDelete;
